<template>
  <div>
    <v-row v-for="(field, index) in inputFieldList" :key="index">
      <v-col cols="12" sm="11" md="11">
        <v-text-field
          class="textField"
          filled
          v-model.trim="field.value"
          :label="`${$t('people.lblDescription')}*`"
          @input="addInputField"
          dense
          :requiredMessage="$t('people.reqDescription')"
          :required="index === 0 || index !== inputFieldList.length - 1"
          :rules="isTextUnique(field.value, index)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="1" md="1">
        <v-tooltip bottom v-if="field.showRemoveButton">
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              width="32"
              min-width="32"
              small
              color="primaryDark"
              v-if="field.showRemoveButton"
              @click.stop.prevent="removeInputField(field)"
            >
              <v-icon size="16">mdi-delete</v-icon>
            </a-btn>
          </template>
          <span>{{ $t("btnDelete") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "RepeatFormInput",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "Description",
    },
    allHistoryData: {
      type: Array,
      default: () => [],
    },    
    yearMonth: String,
    isNewHistory: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cloneText: [],
      currentInputValue: "",
      regExp: /[一-龠ぁ-ゔァ-ヴーa-zA-Zａ-ｚＡ-Ｚ 々〆〤]/,
    };
  },
  computed: {
    inputFieldList: {
      get() {
        return this.getInputFieldList(this.value);
      },
      set(value) {
        const values = value.map((field) => field.value);
        this.$emit("input", _.initial(values));
      },
    },
  },
  methods: {
    getInputFieldList,
    getUniqueId,
    addInputField,
    removeInputField,
    isTextUnique,
  },
};

function getInputFieldList(values) {
  const list = [];
  values.forEach((value) => {
    list.push({ value, showRemoveButton: true, id: this.getUniqueId() });
  });
  list.push({ value: "", showRemoveButton: false, id: this.getUniqueId() });
  return list;
}

function addInputField(value) {
  this.$emit("inputValue", value);

  this.currentInputValue = value;
  const values = this.inputFieldList.map((field) => field.value);

  this.$emit("input", _.compact(values));
}

function removeInputField(field) {
  this.inputFieldList = _.remove(this.inputFieldList, (n) => n.id !== field.id);
}

function getUniqueId() {
  return `_${Math.random().toString(36).substr(2, 9)}`;
}

function isTextUnique(value, index) {
  const isReq = index === 0 || index !== this.inputFieldList.length - 1;
  if (isReq && value === "") {
    return [this.$t("people.reqDescription")];
  }
  if (value !== "") {
    if (!this.regExp.test(value)) {
      return [this.$t("poll.lblReqChar")];
    }
  }
  const cloneText = _.cloneDeep(_.compact(this.value));
  const indexOf = cloneText.indexOf(value);
  if (indexOf > -1) {
    cloneText.splice(indexOf, 1);
  }
  const isExist = cloneText.some(
    (s) => String(s).toLowerCase() === String(value).toLowerCase()
  );
  
  if(this.isNewHistory) {
    var alredyExist = this.allHistoryData.filter((i) => {
      if(String(i.yearMonth).toLowerCase() === String(this.yearMonth).toLowerCase()) {
        return i.description.some(
          (s) => String(s).toLowerCase() === String(value).toLowerCase()
        );
      }
    })
  }  
  
  if (isExist || (alredyExist && alredyExist.length > 0)) {
    return [this.$t("poll.lblReqDescription")];
  }
  return [true];
}
</script>

<style scoped>
.textField {
  font-family: 'Noto Sans JP' !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  max-height: 68px !important;
  color: var(--v-neutralGray-base) !important;  
  align-items: center !important;
  border-radius: 0 !important;
}
.textField > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
  height: 48px !important;
}
.textField /deep/ .v-input__control {
  border-radius: 0 !important;
}
.textField > .v-input__control > .v-input__slot > .v-text-field__slot {
  color: var(--v-neutralGray-base) !important;
}
.textField /deep/ .v-input__prepend-outer {
  align-self: flex-start !important;
}
</style>